import React from 'react';
import styled from 'styled-components';
import Container from 'src/components/core/Container';
import theme from 'src/components/theme/theme';
import shadow from 'src/components/theme/shadows';

const StyledFooter = styled.footer`
    background-color: white;
    z-index: 1000;
    box-shadow: ${shadow(10)};
    padding: 0.2rem 0;
`

const StyledContainer= styled(Container)`
    padding-top: 0;
    padding-bottom: 0;
`

const StyledFooterText = styled.h3`
    font-family: "Cinzel";
    font-size: 1rem;
    font-weight: 500; 
    text-align: right;
    padding: 0 1rem; 
    margin: 0;  
    @media (min-width: 578px){
        padding: 0 2rem;
    }
    a{
        text-decoration: none;
        color: inherit;
    }
`

const StyledFooterContainer = styled.div`
    display: flex;
    justify-content: space-between;
`

const Footer = ()=>{

    return(
        <StyledFooter>
            <StyledFooterContainer>
            <StyledFooterText><a href="mailto:jennings.laurence@gmail.com">website by lj</a></StyledFooterText>          
            <StyledFooterText>Martin Jennings &copy;</StyledFooterText>
            </StyledFooterContainer>
        </StyledFooter>
    )
}

export default Footer;